import { Box, Typography, Divider } from "@mui/material"
import { ReactComponent as LocationIcon } from "../../../assets/imgs/icons/location.svg"
import { ReactComponent as ClockRefreshIcon } from "../../../assets/imgs/icons/clockRefresh.svg"
import { ReactComponent as PersonBlueIcon } from "../../../assets/imgs/icons/personBlue.svg"
import { ReactComponent as WalletIcon } from "../../../assets/imgs/icons/wallet.svg"
import { useFormattedOperatingHours } from "../../../utils/useFormattedOperatingHours"

export default function VenueDetails({ detailsSx, tenant, roomStats }) {
  const branch = tenant?.data?.branches[0]
  const priceRange = branch?.price_range
  const fallbackMinPrice = priceRange
    ? Number(String(priceRange).split("~")[0])
    : 0

  const startsAtPrice =
    Number.isFinite(roomStats?.startsAtPrice) && roomStats?.startsAtPrice > 0
      ? Number(roomStats.startsAtPrice)
      : fallbackMinPrice

  const capacityLabel =
    roomStats?.capacityRangeLabel ||
    (branch?.capacity_range ? String(branch.capacity_range) : "")

  const capacityParts = capacityLabel
    ? String(capacityLabel)
        .split("~")
        .map((value) => value.trim())
        .filter(Boolean)
    : []

  const maxCapacityLabel = capacityParts.length
    ? capacityParts[capacityParts.length - 1]
    : ""

  const formattedHours = useFormattedOperatingHours(branch?.operating_hours)

  const tenantDetails = [
    {
      icon: <LocationIcon fontSize="small" color="action" />,
      text: branch?.address,
    },
    {
      icon: <ClockRefreshIcon fontSize="small" color="action" />,
      text: formattedHours,
    },
    {
      icon: <PersonBlueIcon fontSize="small" color="action" />,
      text: maxCapacityLabel ? `Up to ${maxCapacityLabel} guests` : "",
    },
    {
      icon: <WalletIcon fontSize="small" color="action" />,
      text: `Starts at \u20B1${startsAtPrice.toLocaleString()}`,
    },
  ].filter((item) => !!item.text)

  return (
    <>
      <Typography
        sx={{
          fontSize: { xs: "18px", md: "24px" },
          fontWeight: 800,
          color: "text.heading",
          mt: 2,
          mb: { xs: 2, md: 0 },
        }}
      >
        {tenant?.data?.name}
      </Typography>

      {tenantDetails.map((item, idx) => (
        <Box
          key={idx}
          sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}
        >
          {item.icon}
          <Typography sx={detailsSx}>{item.text}</Typography>
        </Box>
      ))}

      <Divider sx={{ my: 5 }} />
    </>
  )
}
